import { stockActions } from '../../services';

export const stockReducer = ( state = {}, action ) => {
  const newState = { ...state };
  switch ( action.type ) {
    case stockActions.LOADING:
      const products = Array.isArray( action.products ) ? action.products : [action.products];

      products.forEach( m => newState[m.MaterialId] = { loading: true } );

      return newState;
    case stockActions.RETRIEVED:
      const stockResult = Array.isArray( action.result ) ? action.result : [action.result];

      stockResult.forEach( m => newState[m.name] = m );
      return newState;

    case stockActions.FAILED:
      const failedProducts = Array.isArray( action.products ) ? action.products : [action.products];
      
      failedProducts.forEach( m => newState[m.MaterialId] = { loading: false } );
      return newState;
     default:
       return state; 
  }
}